<template>
    <div>
        <template class="pa-3">
            <v-snackbar
                v-model="snackbar" 
                top 
                vertical 
                :timeout="5000"
            >
                {{ Mensaje }}
                <v-btn
                    color="info"
                    text
                    @click="snackbar = false"
                >
                    Cerrar
                </v-btn>
            </v-snackbar>
            
            <v-row flat color="white"  class="pa-2">
                
                <v-col cols="12" sm="12">
                    <v-row class="pa-2">
                        <v-col cols="12" sm="3">
                            <v-card-title>Ventas X Horas</v-card-title>
                        </v-col>
                        <v-col cols="12" sm="4">    
                            <v-text-field 
                                filled 
                                v-model="search"  
                                append-icon="mdi-magnify"
                                label="Buscar" 
                                single-line 
                                hide-details
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field filled v-model="start" type="date" label="Fecha inicial"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field filled v-model="end"  type="date" label="Fecha final"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="1">
                            <v-btn :loading="loading" color="info" @click="loadVentasPorHora()" fab > 
                                <v-icon fab> mdi-cloud-search </v-icon> 
                            </v-btn>
                        </v-col>
                    </v-row>
                    
                    <!-- Ajustar la altura del v-card -->
                    <v-card style="height: auto; width: 100%;">
                        <div class="pa-1">
                            <canvas id="ventasHoraChart" style="position: relative; height: 250px; width: 100%;"></canvas>
                        </div>
                    </v-card>
                </v-col>
                
            </v-row>
        </template>
    </div>
</template>

<script scoped>
import axios from 'axios'
import Chart from 'chart.js'
  export default {
    data: () => ({
    end: new Date().toISOString().substr(0, 10),
    start: new Date().toISOString().substr(0, 10),
    snackbar: true,
	Localidades:[],
	Localidad: '',
	loading: true,
	infoVentas:[],
	horas:[],
    }),

    methods: {
		async listarAsociadas(){
			var items = [];
			let me=this;
			me.Localidades.push(me.$store.state.usuario.localidad);
			this.Localidad = this.$store.state.usuario.localidad
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			await axios.get('api/LocalidadesAsociadas/'+this.$store.state.usuario.nombre,configuracion).then(function(response){
				items=response.data;
				items.map(function(x){
					me.Localidades.push(x.localdiadAsociada);
				});
			}).catch(function(error){
				alert("Producto no encontrado");
				me.modelCarga=false;
			});
    	},
		loadVentasPorHora() {
			let me = this;
			let localidad = this.Localidad; // Cambia 'TuLocalidad' por la localidad que necesitas
			this.loading= true;
			// Formatea las fechas para enviarlas en la URL
			let formattedFechaInicio = this.start;
			let formattedFechaFin = this.end;

			axios.get(`api/RepVentasVistas/VentasPorHoraEntreFechas/${localidad}/${formattedFechaInicio}/${formattedFechaFin}`)
			.then(response => {
				const data = response.data;
				me.infoVentas = data.map(v => v.promedioVentas);
				me.horas = data.map(v => v.hora + ":00");
				me.loading = false;
				me.renderChart();
				me.loadVentasPorFamilia();
			})
			.catch(error => {
				console.error("Hubo un error al obtener los datos", error);
			});
		},
		renderChart() {
			var ctx = document.getElementById("ventasHoraChart");
			var myChart = new Chart(ctx, {
				type: 'bar',
				data: {
					labels: this.horas,
					datasets: [{
						label: 'Promedio de Ventas por Hora',
						data: this.infoVentas,
						backgroundColor: 'rgba(254, 200, 68, 1)',  // Más transparencia
						borderColor: 'rgba(255, 161, 38, 01)',  // Color más sutil
						borderWidth: 1
					}]
				},
				options: {
					scales: {
						yAxes: [{
							gridLines: {
								color: 'rgba(200, 200, 200, 1)',  // Líneas más sutiles
								lineWidth: 0.5
							},
							ticks: {
								beginAtZero: true,
								fontColor: 'rgba(200, 200, 200, 0.5)'  // Color de texto más suave
							}
						}],
						xAxes: [{
							gridLines: {
								display: false  // Desactiva las líneas horizontales
							},
							ticks: {
								fontColor: '#3e4356'
							}
						}]
					},
					responsive: true,
					title: {
						display: true,
						text: 'Promedio de Ventas por Hora',
						fontColor: '#3e4356',  // Asegúrate de que el color del título coincida
						fontFamily: 'generalFont', // Reemplaza con tu fuente
					},
					legend: {
						labels: {
							fontColor: '#3e4356', // Ajusta el color de la leyenda
							fontFamily: 'generalFont' // Reemplaza con tu fuente
						}
					}
				}
			});
		},

    },
	mounted(){
		this.listarAsociadas();
		this.loadVentasPorHora();
	}
  }

</script>